import React from "react";
import ProductSelection from "./ProductSelection";
import style from "./ProductOption.module.css";

export default function ProductOption({
  option,
  activeSelectionIds,
  handleOptionSelectionClick,
  handleQtyChange,
  getLinkedSelections,
  availableOptions
}) {
  const doSomeSelectionsHavePrices = option.selections.some(
    selection => selection.product.price !== null
  );
  const isVisible = option.display === "1" && doSomeSelectionsHavePrices;

  return isVisible ? (
    <div>
      <h2 className={style.title}>
        {`${option.title}${option.required === "1" ? " (Required)" : ""}`}
      </h2>

      <table className={style.table}>
        <tbody>
          {option.selections.map(selection => (
            <ProductSelection
              key={selection.selection_id}
              selection={selection}
              handleSelectionClick={(selection, action) =>
                handleOptionSelectionClick(option, selection, action)
              }
              handleQtyChange={(selectionId, qty) =>
                handleQtyChange({
                  optionId: option.option_id,
                  selectionId,
                  qty,
                  allOptions: availableOptions
                })
              }
              isActive={activeSelectionIds.includes(selection.selection_id)}
              type={option.type}
              linkedParts={getLinkedSelections(selection)}
            />
          ))}
        </tbody>
      </table>
    </div>
  ) : null;
}
